import { DefaultCardLayout } from './normalizeDashboard'
import { ensureUniqueObjectIds } from '@edge/spark/utils'
import type { DashboardLayout } from '../types'

/**
 * Returns DefaultCardLayout missing savedDashboards
 *
 * Parses dashboard json string to DashboardLayout
 *
 * Makes sure that each dashboard has unique id
 *
 *  */
export const normalizeDashboards = (savedDashboards: (string | null)[] | null | undefined): DashboardLayout[] => {
    if (!savedDashboards || savedDashboards.length <= 0) {
        return [DefaultCardLayout]
    }

    const parsedDashboards = savedDashboards.map((d) => (d ? (JSON.parse(d) as DashboardLayout) : DefaultCardLayout))

    const addMissingCardsArray = parsedDashboards.map((d) => {
        if (!d.cards) {
            d.cards = []
        }

        return d
    })

    const onlyUniqueIds = ensureUniqueObjectIds(addMissingCardsArray) as DashboardLayout[]

    return onlyUniqueIds
}

export default normalizeDashboards
